var App = {
    init: function () {
        if ($('.xzoom, .xzoom-gallery').length) {
            this.zoomItems();
        }

    },
    zoomItems: function(){
        $(".xzoom, .xzoom-gallery").xzoom({
            tint: '#333',
            Xoffset: 15
        });
    }
}

$(function () {
    App.init();
});

(function () {
    'use strict'
    // document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
    //     this.classList.toggle('collapsed');
    //     document.querySelector('.offcanvas-collapse').classList.toggle('open');
    //     //document.querySelector('.nav-container').classList.toggle('full-bg');
    // })

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    AOS.init({
        once: true
    });

})()
